import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import { Card, Row, Col, Collapse } from 'antd';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import TweenOne from 'rc-tween-one';
import { enquireScreen } from 'enquire-js';
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { Panel } = Collapse;
const { Meta } = Card;

export default class DatalinkContent1 extends React.Component {
    callback(key) {
        console.log(key);
    }

    render() {
        const cardStyle = {
            width: 320,
            padding: 8,
            margin: "0 auto"
        }
        return (
            <ScrollOverPack className='Datalink-content1'>
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <TweenOne
                            key="image"
                            className="image-wrapper Datalink-content-image1"
                            animation={{ x: 0, opacity: 1, ease: 'easeOutQuad' }}
                            style={{ transform: 'translateX(-100px)', opacity: 0 }}
                            title="Onboard/ground processing unit"
                        />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <QueueAnim
                            key="QueueAnim"
                            type={['bottom', 'top']}
                            delay={200}
                            className='text-wrapper Datalink-text'
                        >
                            <p style={{ fontSize: isMobile?'22px':'28px',marginLeft: '8px' ,color:'#fff'}}>实用的传输方案，够长够可靠</p>
                            <p><span>· </span>图像、数据、控制一体化传输。</p>
                            <p><span>· </span>GNSS丢失时无线电测距和定位。</p>
                            <p><span>· </span>干扰情况下的自动跳频。</p>
                            <p><span>· </span>实时信号强度显示和记录。</p>
                            <p><span>· </span>点对点高清传输，1080P/60fps视频。</p>
                        </QueueAnim>
                    </Col>
                </Row>


            </ScrollOverPack>
        )

    }
}
